
import { defineComponent,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import Header from '@/components/Header.component.vue'; // @ is an alias to /src
import SideBar from '@/components/SideBar.component.vue'; // @ is an alias to /src
import SearchingBar from '@/components/SearchingBar.component.vue';
import ListDevices from '@/components/ListDevices.component.vue'; // @ is an alias to /src
import ListMessages from '@/components/ListMessages.component.vue'; // @ is an alias to /src
import {Device} from "@/models/devices.interface";
import {Message} from "@/models/message.interface";
import {SMSMessage} from "@/models/message.interface";
import {DeviceService} from "@/services/device.services";
import {UserService} from "@/services/user.service";
import {FilesService} from "@/services/files.service"
import {useStore} from "vuex";
import router from "@/router";

export default defineComponent({
  name: 'HomeView',
  components: {
    ListDevices,
    Header,
    ListMessages,
    SideBar,
    SearchingBar
  },
  setup(){

      document.body.style.background = 'url('+require("@/img/11.jpg")+')';
      document.body.className= "prueba";
      const store = useStore();
      const serviceUser = new UserService();

      let pagina =ref(1);

    let objBusqueda = {phone_number:"all",status:"",finicio:null,ffin:null};
    
      onMounted(()=>{
	try{

	const userStored =  serviceUser.fetch();
	  if(!userStored){
	    router.push("login");
	  }
	  else{
	  
	  }
	}catch(err){
	  console.log(err);
	}
      });
      const logout = ()=>{
         serviceUser.clean();
	 store.dispatch("set_current_user",{token:"",name:"",lastname:"",profiles:[]});
	try{

	router.push("login");
	}catch(err){
          console.log(err);
	}
      };//fin de logout


      const cUser = computed(()=>{ return store.getters.getCurrentUser});

      const messages:Ref<Message[]>=ref([]);
      const title:Ref<string>=ref("");
      let devices:Ref<SMSMessage[]>= ref([]);
      let phone_changed:Ref<string>=ref('');

      provide("messages_from_phone",messages);
      provide("origin_title",title);
      provide("devices_with_messages",devices);
      provide("pagina",pagina);

      const service = new DeviceService();
      const fileService = new FilesService();
    watchEffect(()=>{messages.value.length;});
    const asign = async() =>{
      //devices.value = await service.getAllByMessages(serviceUser.fetch());
      devices.value = await service.getDevicesByNumberAndStatus(serviceUser.fetch().token,"all","unattended");

    };
      asign();
      const searchsms= async (evento)=>{
	objBusqueda=evento;
	devices.value = await service.getDevicesByNumberAndStatus(serviceUser.fetch().token,evento.phone_number,evento.status,evento.finicio,evento.ffin);
      }

    const smsExport = async(evento)=>{
       fileService.downloadSmsFile(serviceUser.fetch().token,evento.phone_number,evento.status,evento.finicio,evento.ffin);
    };

    const fetchMoreMessages = async(evt)=>{
	devices.value = await service.getDevicesByNumberAndStatus(serviceUser.fetch().token,objBusqueda.phone_number,objBusqueda.status,objBusqueda.finicio,objBusqueda.ffin,pagina.value);
    }

    const fetchLessMessages = async(evt)=>{
	if(pagina.value>0){
	    devices.value = await service.getDevicesByNumberAndStatus(serviceUser.fetch().token,objBusqueda.phone_number,objBusqueda.status,objBusqueda.finicio,objBusqueda.ffin,pagina.value);
	}
    }


    return{devices,messages,title,cUser,logout,searchsms,smsExport,fetchMoreMessages,fetchLessMessages};
  }//find e setup
});
